import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84d821a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container px-5 py-4" }
const _hoisted_2 = { class: "row g-3 justify-content-center" }
const _hoisted_3 = {
  key: 0,
  class: "col-12 text-center my-5"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, null, -1))
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = {
  key: 0,
  class: "col-12 col-lg-10"
}
const _hoisted_7 = { class: "row card light mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header text-center" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "RESERVA")
], -1))
const _hoisted_9 = { class: "card-body row gy-3" }
const _hoisted_10 = { class: "col-12 col-lg-6 text-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Código", -1))
const _hoisted_12 = { class: "col-12 col-lg-6 text-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Estado", -1))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "col-12 col-lg-6 text-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Hora", -1))
const _hoisted_19 = {
  key: 0,
  class: "col-12 col-lg-6 text-center"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Vehículo", -1))
const _hoisted_21 = {
  key: 0,
  class: "card-footer text-muted text-end"
}
const _hoisted_22 = {
  class: "modal fade",
  id: "ModalDivit",
  tabindex: "-1",
  "aria-labelledby": "ModalDivitLabel",
  "aria-hidden": "true"
}
const _hoisted_23 = { class: "modal-dialog" }
const _hoisted_24 = { class: "modal-content" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title title-cancelar",
    id: "ModalDivitLabel"
  }, " CANCELACIÓN DE RESERVA "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-body texto-cancelar text-dark" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "¿Estás seguro que deseás cancelar la reserva?")
], -1))
const _hoisted_27 = { class: "modal-footer botones" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary boton-cancelar py-2",
  "data-bs-dismiss": "modal"
}, " Cancelar ", -1))
const _hoisted_29 = { class: "row card mb-3" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header text-center" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "DATOS PERSONALES")
], -1))
const _hoisted_31 = { class: "card-body row gy-3" }
const _hoisted_32 = { class: "col-12 col-lg-12 text-center text-lg-start" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-muted" }, "Email", -1))
const _hoisted_34 = { class: "col-12 col-lg-4 text-center text-lg-start" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-muted" }, "Nombre y apellido", -1))
const _hoisted_36 = { class: "col-12 col-lg-4 text-center text-lg-start" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-muted" }, "Documento", -1))
const _hoisted_38 = { class: "col-12 col-lg-4 text-center text-lg-start" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-muted" }, "Teléfono", -1))
const _hoisted_40 = { class: "col-12 col-lg-4 text-center text-lg-start" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-muted" }, "Dirección", -1))
const _hoisted_42 = { class: "col-12 col-lg-4 text-center text-lg-start" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-muted" }, "Provincia", -1))
const _hoisted_44 = { class: "col-12 col-lg-4 text-center text-lg-start" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-muted" }, "Localicad", -1))
const _hoisted_46 = {
  key: 1,
  class: "col-12 text-center my-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading.status)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.loading.text), 1)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.voucher)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("h5", null, _toDisplayString(_ctx.voucher.codigoReserva), 1)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        (_ctx.voucher.cancelada === '0')
                          ? (_openBlock(), _createElementBlock("h5", _hoisted_14, "Vigente"))
                          : (_ctx.voucher.cancelada === '1')
                            ? (_openBlock(), _createElementBlock("h5", _hoisted_15, "Cancelada"))
                            : (_ctx.voucher.cancelada === '-1')
                              ? (_openBlock(), _createElementBlock("h5", _hoisted_16, "Pendiente"))
                              : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("h5", null, _toDisplayString(_ctx.voucher.turno.inicioTexto), 1)
                      ]),
                      (_ctx.voucher.vehiculo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _hoisted_20,
                            _createElementVNode("h5", null, _toDisplayString(_ctx.voucher.vehiculo), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (['0','-1'].includes(_ctx.voucher.cancelada))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createVNode(_component_router_link, {
                            tag: "label",
                            class: "text-decoration-none form-check-label fw-bold d-inline",
                            to: { name: 'voucher_cancelar' },
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#ModalDivit"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Cancelar Reserva ")
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("div", _hoisted_24, [
                                _hoisted_25,
                                _hoisted_26,
                                _createElementVNode("div", _hoisted_27, [
                                  _hoisted_28,
                                  _createElementVNode("button", {
                                    class: "btn-danger btn boton-confirmar py-2",
                                    type: "button",
                                    "data-bs-dismiss": "modal",
                                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmar && _ctx.confirmar(...args)))
                                  }, " Confirmar ")
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("h5", null, _toDisplayString(_ctx.voucher.email), 1)
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("h5", null, _toDisplayString(_ctx.voucher.nombreApellido), 1)
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _hoisted_37,
                        _createElementVNode("h5", null, _toDisplayString(_ctx.voucher.documento), 1)
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _hoisted_39,
                        _createElementVNode("h5", null, _toDisplayString(_ctx.voucher.telefono), 1)
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _hoisted_41,
                        _createElementVNode("h5", null, _toDisplayString(_ctx.voucher.direccion), 1)
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _hoisted_43,
                        _createElementVNode("h5", null, _toDisplayString(_ctx.voucher.provincia), 1)
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createElementVNode("h5", null, _toDisplayString(_ctx.voucher.localidad), 1)
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.loading.text), 1)
                ]))
          ], 64))
    ])
  ]))
}